import { CustomerCheckoutPart } from "@/checkout/Sections/CustomerSection/types";
import { CustomerType } from "@cappelendamm/e-commerce-services";

export const DEFAULT_CUSTOMER_VALUES: CustomerCheckoutPart = {
  type: CustomerType.INDIVIDUAL,
  delivery: {
    firstName: "",
    lastName: "",
    street: "",
    postalCode: "",
    city: "",
    country: "",
  },
  billingAddressIsSameAsDeliveryAddress: true,
  billing: {
    firstName: "",
    lastName: "",
    street: "",
    postalCode: "",
    city: "",
    country: "",
  },
  email: "",
  phone: "",
  birth: {
    year: "",
    month: "",
    day: "",
  },
};
